module.exports = __webpack_public_path__ + "static/media/Yarrabah.6d39d4c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Yarrabah.jpg
// module id = 673
// module chunks = 0